import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import tw, { styled } from 'twin.macro';
import { BriefcaseIcon } from '@heroicons/react/24/outline';
import { BaseModal, ButtonV2 } from '@restworld/ui-ds';
import { useAuth } from '@restworld/feature-authentication';

interface PaymentSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ModalContent = styled.div`
  ${tw`flex flex-col gap-2.5 items-center w-full text-center`}
`;

const Description = styled.p`
  ${tw`text-[16px] font-normal text-[#1c1c33] leading-[1.5]`}
`;

const ButtonsContainer = styled.div`
  ${tw`flex flex-col w-full`}
`;

export const PaymentSuccessModal: React.FC<PaymentSuccessModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('payment-and-invoices');
  const router = useRouter();
  const { user } = useAuth();

  const handleManageJobPositions = React.useCallback(() => {
    onClose();
    router.push('/employer/job-positions');
  }, [onClose, router]);

  const footer = (
    <ButtonsContainer>
      <ButtonV2 variant="primary" StartIcon={BriefcaseIcon} onClick={handleManageJobPositions}>
        {t('manage_job_positions')}
      </ButtonV2>
    </ButtonsContainer>
  );

  return (
    <BaseModal
      open={isOpen}
      onClose={onClose}
      title={t('invoice_settled_successfully')}
      footer={footer}
      showCloseIcon
      modalStyles={[tw`max-w-[640px]`]}
    >
      <ModalContent>
        <Description>{t('invoice_settled_description', { name: user?.name || t('hi') })}</Description>
      </ModalContent>
    </BaseModal>
  );
};

export default PaymentSuccessModal;
